import StockPositionChartsContainer from 'components/organisms/StockPositionChartsContainer';
import StockPositionTopContainer from 'components/organisms/StockPositionTopContainer';
import FilterProvider from 'providers/Filter';
import React from 'react';
import StockPositionGridContainer from '../../StockPositionGridContainer';

const StockPositionPresentation = () => {
  const [updatedAt, setUpdatedAt] = React.useState<Date | null>(null);

  return (
    <>
      <FilterProvider>
        <StockPositionTopContainer updatedAt={updatedAt} />
        <StockPositionChartsContainer updatedAt={updatedAt} />
        <StockPositionGridContainer setUpdatedAt={setUpdatedAt} />
      </FilterProvider>
    </>
  );
};

export default StockPositionPresentation;
